import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { componentKey, setDeleteRecipientsModal, setLoadingState, setPaginationState, setRecipientsList, setSelectPayerModalOpen, setShouldReloadRecipientList, } from "./MoveRecipientsSlice";
import { addNotifications } from "../../toaster/ToasterPortalSlice";
import { PAGE_STATE } from "../../constants/constants";
import Payer from "../../../../libs/utility/Payer";
import RecipientDataService from "../../../../services/RecipientDataService";
import { TOASTER_VARIANT } from "../../../components/toast/constants";
import General from "../../../../libs/utility/General";

export const { getRecipientLists, deleteRecipients, switchRecipients } = {

    getRecipientLists: (payload) => {
        return {
            type: "MOVE_RECIPIENT/GET_RECIPIENTS_LIST_FOR_MOVE_RECIPIENT",
            payload
        }
    },

    deleteRecipients: (payload) => {
        return {
            type: "MOVE_RECIPIENT/DELETE_RECIPIENTS",
            payload
        }
    },

    switchRecipients: (payload) => {
        return {
            type: "MOVE_RECIPIENT/SWITCH_RECIPIENTS",
            payload
        }
    },

}

function* getRecipientListsAsync(action) {

    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING}))

        const { PageNumber, PageSize, FilterText, IsDesc, IdNumber } = action.payload;

        const params = {
            PageNumber: PageNumber || 1,
            PageSize: PageSize || 10,
            FilterText: FilterText || "",
            IdNumber: IdNumber || "",
            IsDesc: IsDesc || false,
        }

        const response = yield RecipientDataService.getRecipientLists(params);

        const { Message, Status } = response?.data;
        const Data =  General.extractDataFromResponseData(response?.data)

        if (Status) {

            yield put(setRecipientsList(Data));

            yield put(setPaginationState({ ...action.payload, totalRecipients: General.extractPaginationTotalFromResponse(response.data) }))

        } else {
            yield put(addNotifications({ heading: "Failed to get the recipients list" }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the recipients list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }

}

function* deleteRecipientsAsync(action) {

    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING }))

        const { PayerId, RecipientIds } = action.payload;

        const data = {
            PayerId,
            RecipientIds
        }

        const response = yield RecipientDataService.deleteRecipient(data);

        const { Data, Message, Status } = response?.data;

        if (Status) {
            let message = Data.SuccessCount == 0 ? "You can not delete this Recipient because forms are attached with this Recipient." : "";
            let headingText = Data.SuccessCount == 0 ? "Recipients Not Deleted" : "";
            let variant = Data.SuccessCount == 0 ? TOASTER_VARIANT.WARNING : ""

            message = Data.FailureCount > 0 && Data.SuccessCount > 0 ? "Some of Recipients deleted successfully. Some might have forms created under them." : message;
            headingText = Data.FailureCount > 0 && Data.SuccessCount > 0 ? "Some Recipients Deleted" : headingText;
            variant = Data.FailureCount > 0 && Data.SuccessCount > 0 ? TOASTER_VARIANT.SUCCESS : variant


            message = Data.FailureCount == 0 ? "Recipients deleted successfully." : message;
            headingText = Data.FailureCount == 0 ? "Recipients Deleted" : headingText;
            variant = Data.FailureCount == 0 ? TOASTER_VARIANT.SUCCESS : variant

            yield put(setDeleteRecipientsModal(false));

            yield put(setShouldReloadRecipientList(true));
            yield put(addNotifications({ heading: headingText, variant: variant, message: message }));
        } else {
            yield put(addNotifications({ heading: "Failed to delete recipients" }));
            yield put(setDeleteRecipientsModal(false));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the recipients list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }

}

function* switchRecipientsAsync(action) {

    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING}))

        const { PayerId, RecipientIds } = action.payload;

        const data = {
            PayerId,
            RecipientIds
        }

        const response = yield RecipientDataService.switchRecipients(data);

        const { Data, Message, Status } = response?.data;

        if (Status) {

            yield put(setSelectPayerModalOpen(false));

            yield put(setShouldReloadRecipientList(true));
            yield put(addNotifications({ heading: 'Recipients switched successfully!', variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Failed to switch recipients" }));
            yield put(setSelectPayerModalOpen(false));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to switch recipients", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }

}

function* rootSaga() {
    yield all([
        takeLatest(getRecipientLists().type, getRecipientListsAsync),
        takeLatest(deleteRecipients().type, deleteRecipientsAsync),
        takeLatest(switchRecipients().type, switchRecipientsAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);